import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useAuth } from "hooks/useAuth";
import { logout } from "slices/auth/reducer";
import { fetchUser } from "slices/auth/thunk";
import Loader from "Components/Common/Loader";
import { RootState } from "store";
import usePageTracking from "hooks/usePageTracking";


const AuthProtected = (props: any) => {
    const dispatch: any = useDispatch();
    const { isAuthenticated, loading } = useAuth();

    const [userFetched, setUserFetched] = useState(false);

    const userId = useSelector((state: RootState) => state.auth.user?.uuid);

    usePageTracking(userId);

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchUser()).finally(() => setUserFetched(true));
        } else {
            dispatch(logout());
            setUserFetched(true);
        }
    }, [isAuthenticated, dispatch]);

    if (!isAuthenticated && !loading) {
        return <Navigate to={{ pathname: "/login" }} />;
    }

    if (loading || !userFetched) return <Loader />;

    return <>{props.children}</>;
};

export default AuthProtected;